export default __webpack_public_path__ + "static/media/axis-icon.9e5f2d52.svg";